import { useI18n } from "@/context/LanguageContext";
import { TAGLINES } from "@/i18n/translations";

const LOGO = `${process.env.PUBLIC_URL}/logo.png`;

export function BrandLogo({ variant = "dark", showTagline = false, className = "", size = 36 }) {
  const ctx = useI18n();
  const lang = ctx?.lang || "it";
  const nameColor = variant === "light" ? "text-white" : "text-[#1B3A5B]";
  const subColor = variant === "light" ? "text-slate-300" : "text-slate-400";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img src={LOGO} alt="Certy Trace" style={{ width: size, height: size }} className="object-contain shrink-0" />
      <div className="leading-none">
        <div className={`font-heading font-black tracking-tight text-lg ${nameColor}`}>Certy Trace</div>
        {showTagline && (
          <div className={`text-[8px] font-mono uppercase tracking-[0.18em] mt-1 ${subColor}`}>
            {TAGLINES[lang] || TAGLINES.it}
          </div>
        )}
      </div>
    </div>
  );
}
